import { StringUtils } from '@teleporthq/teleport-shared';
const getContentOfStyleKey = (styleValue) => {
    if (styleValue.type === 'static') {
        return styleValue.content;
    }
    throw new Error(`getContentOfStyleKey received unsupported ${JSON.stringify(styleValue, null, 2)} UIDLNodeStyleValue value`);
};
export const getContentOfStyleObject = (styleObject) => {
    return Object.keys(styleObject).reduce((acc, key) => {
        acc[key] = getContentOfStyleKey(styleObject[key]);
        return acc;
    }, {});
};
export const getTokensContentFromTokensObject = (tokens) => {
    return Object.keys(tokens || {}).reduce((acc, key) => {
        acc[StringUtils.generateCSSVariableName(key)] = tokens[key].content;
        return acc;
    }, {});
};
export const getCSSVariablesContentFromTokenStyles = (styleObject) => {
    return Object.keys(styleObject || {}).reduce((acc, key) => {
        const style = styleObject[key];
        if (style.type === 'dynamic' && style.content.referenceType === 'token') {
            acc[key] = `var(${StringUtils.generateCSSVariableName(style.content.id)})`;
        }
        return acc;
    }, {});
};
//# sourceMappingURL=style-utils.js.map